export default __webpack_public_path__ + "static/media/Snd_LowerQMagicC.80f994f2.mp3";